module.exports = __webpack_public_path__ + "static/img/img-2.03f4858d.jpg";